package com.klantenstop.web.data.models.dto.responses

import kotlinx.serialization.Serializable

@Serializable
data class AddressValidationDto(
    val valid: Boolean,
    val latitude: Double? = null,
    val longitude: Double? = null,
    val message: String? = null
)
